module.exports = __webpack_public_path__ + "img/aerospace.c3783626.svg";